module.exports = __webpack_public_path__ + "img/Quigley-OTP-human-mobile-img.26a7fd3d.png";